import {
    UPDATE_USER_MARKETING_LOCALE_REQUEST,
    UPDATE_USER_MARKETING_LOCALE_SUCCESS,
    UPDATE_USER_MARKETING_LOCALE_ERROR,
} from '../constants/ActionTypes';

export function isUpdatingUserMarketingCountryLang(state = false, action) {
    switch (action.type) {
        case UPDATE_USER_MARKETING_LOCALE_REQUEST:
            return true;
        case UPDATE_USER_MARKETING_LOCALE_SUCCESS:
        case UPDATE_USER_MARKETING_LOCALE_ERROR:
            return false;
    }
    return state;
}

export function updateUserMarketingCountryLangError(state = false, action) {
    switch (action.type) {
        case UPDATE_USER_MARKETING_LOCALE_REQUEST:
        case UPDATE_USER_MARKETING_LOCALE_SUCCESS:
            return false;
        case UPDATE_USER_MARKETING_LOCALE_ERROR:
            return true;
    }
    return state;
}
